import { render, staticRenderFns } from "./FootCommon.vue?vue&type=template&id=6f2488c4&scoped=true&"
import script from "./FootCommon.vue?vue&type=script&lang=js&"
export * from "./FootCommon.vue?vue&type=script&lang=js&"
import style0 from "./FootCommon.vue?vue&type=style&index=0&id=6f2488c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2488c4",
  null
  
)

export default component.exports